import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { LeaderSelector, Modal } from 'containers/misc'
import { FormData, Module, ModuleLink } from 'components/misc'
import { modal } from 'redux/modules/app'
import config from 'config'

@connect(null, { modal })
class ParticipantLeader extends PureComponent {
  static propTypes = {
    awardLeader: PropTypes.object,
    refreshAward: PropTypes.func,
    awardId: PropTypes.number,
    orgId: PropTypes.number,
    errors: PropTypes.object,
    modal: PropTypes.func.isRequired,
    submitFailed: PropTypes.bool.isRequired
  }

  render () {
    const { awardLeader, refreshAward, awardId, orgId, errors, submitFailed } = this.props

    const hasError = get(errors, 'id') && submitFailed
    const leaderFirstName =
      get(awardLeader, 'firstName') || get(awardLeader, 'person.firstName')
    const leaderLastName =
      get(awardLeader, 'lastName') || get(awardLeader, 'person.lastName')
    const leaderEmail =
      get(awardLeader, 'email') || get(awardLeader, 'person.email')
    const leaderPhone =
      get(awardLeader, 'phone') || get(awardLeader, 'person.phone')
    const linkName = (leaderFirstName || '---') + ' ' + leaderLastName

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': () => this.props.modal('participant-change-leader'),
        'iconAction': null,
        'isActionLoading': false,
        'intlKeyAction': 'button.change',
        'action': 'Change'
      }
    ]

    return (

      <Module
        title="Leader"
        intlKey="moduleTitle.leader"
        primary
        grid
        hasError={hasError}
        buttonDefinition={buttonDefinition}
      >
        <div className="row">
          <div className="col-xs-4">
            <FormData label="Name" intlKey="label.name">
              {awardLeader && <ModuleLink to={`${config.publicPath}/leaders/${get(awardLeader, 'id')}/detail`}
                                          text={linkName} /> || '---'}
            </FormData>
          </div>
          <div className="col-xs-5">
            <FormData label="Email" intlKey="label.email">
              {leaderEmail || '---'}
            </FormData>
          </div>
          <div className="col-xs-3">
            <FormData label="Phone number" intlKey="label.phone_number">
              {leaderPhone || '---'}
            </FormData>
          </div>
          {hasError && (
            <div className="col-xs-12 base-margin--bottom">
              <span className="form-control-error">
                <FormattedMessage
                  id="participant.leader_must_be_selected"
                  defaultMessage="Leader must be selected"
                />
              </span>
            </div>
          )}
        </div>
        <Modal id="participant-change-leader" customActions wider>
          <LeaderSelector
            modal={this.props.modal}
            refreshAward={refreshAward}
            awardId={awardId}
            decoOrganizationId={orgId}
          />
        </Modal>
      </Module>
    )
  }
}

export default ParticipantLeader
